import { paginatedQuery } from 'lib-shared-api-utils';
import { api } from 'utils/apis/api';
export const queuesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        createQueue: builder.mutation({
            query: ({ queue: data }) => ({
                version: 2,
                path: 'queues',
                method: 'POST',
                data,
            }),
        }),
        readQueue: builder.query({
            query: ({ id }) => ({
                version: 2,
                path: `queues/${id}`,
            }),
        }),
        updateQueue: builder.mutation({
            query: ({ id, queue }) => ({
                version: 3,
                path: `queues/${id}`,
                method: 'PATCH',
                body: queue,
            }),
        }),
        readQueues: builder.query({
            query: (arg) => paginatedQuery(arg, ({ is_archived }) => ({
                version: 3,
                path: 'queues',
                params: {
                    is_archived,
                },
            })),
        }),
        createQueueAgents: builder.mutation({
            query: ({ id, agentIds }) => ({
                version: 2,
                path: `queues/${id}/agents`,
                method: 'PUT',
                body: {
                    agents: agentIds.map((agent_id) => ({
                        agent_id,
                    })),
                },
            }),
        }),
        readQueueAgents: builder.query({
            query: (arg) => paginatedQuery(arg, ({ id }) => ({
                version: 2,
                path: `queues/${id}/agents`,
            })),
        }),
        updateQueueAgents: builder.mutation({
            query: ({ id, agents }) => ({
                version: 2,
                path: `queues/${id}/agents`,
                method: 'PUT',
                body: {
                    agents,
                },
            }),
        }),
        deleteQueueAgents: builder.mutation({
            query: ({ id, agentIds: agents }) => ({
                version: 2,
                path: `queues/${id}/agents`,
                method: 'DELETE',
                body: { agents },
            }),
        }),
        createQueueTeams: builder.mutation({
            query: ({ id, teamIds }) => ({
                version: 2,
                path: `queues/${id}/teams`,
                method: 'PUT',
                body: {
                    agents: teamIds.map((team_id) => ({
                        team_id,
                    })),
                },
            }),
        }),
        readQueueTeams: builder.query({
            query: (arg) => paginatedQuery(arg, ({ id }) => ({
                version: 2,
                path: `queues/${id}/teams`,
            })),
        }),
        updateQueueTeams: builder.mutation({
            query: ({ id, teams }) => ({
                version: 2,
                path: `queues/${id}/teams`,
                method: 'PUT',
                body: {
                    teams,
                },
            }),
        }),
        deleteQueueTeam: builder.mutation({
            query: ({ id, teamId }) => ({
                version: 2,
                path: `queues/${id}/teams/${teamId}`,
                method: 'DELETE',
            }),
        }),
    }),
});
